import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./Reducers/rootReducer"; // تأكد من أن المسار صحيح

const store = configureStore({
  reducer: rootReducer, // ✅ لا حاجة لـ initialState ولا middleware هنا
  devTools: true,
});

export default store;
